import { Api } from 'constants/api';
import { App } from 'constants/app';
import { Channels } from 'constants/channels';
import { Delays } from 'constants/delays';
import { Routes } from 'constants/routes';
import { System } from 'constants/system';

export default {
  Api: Api,
  App: App,
  System: System,
  Delays: Delays,
  Routes: Routes,
  Channels: Channels,
};
